import { each, map, split } from 'lodash-es'

import Subscribe from '@plugin/subscribe'
export default class ControlBase extends Subscribe {
  constructor (groupClass = true, className = '') {
    super()
    const container = document.createElement('div')
    container.classList.add('mapboxgl-ctrl')
    if (groupClass) container.classList.add('mapboxgl-ctrl-group')
    if (className) container.classList.add(className)
    this._container = container
    this._map
  }

  addClassName (className) {
    this._container.classList.add(className)
  }

  removeClassName(className) {
    this._container.classList.remove(className)
  }

  createdButton ({
    tag = 'button',
    children,
    innerText,
    innerHTML,
    className,
    onClick
  }) {
    const button = document.createElement(tag)
    button.onclick = onClick
    if (className) map(split(className, ' '), v => button.classList.add(v))
    if (children) button.appendChild(children.node || children)
    if (innerText) button.innerText = innerText
    if (innerHTML) button.innerHTML = innerHTML
    return button
  }

  addButton (...buttons) {
    each(buttons, item => this._container.appendChild(item))
  }

  onAddControl() {
  }

  onAdd (map) {
    this._map = map
    this.onAddControl(this._container)
    return this._container
  }

  onRemove () {
    this._container.parentNode.removeChild(this._container)
    this._container = null
    this._map = null
  }
}

export class Icon {
  constructor (name) {
    const icon = document.createElement('i')
    icon.classList.add('icon')
    icon.classList.add(name)
    this.node = icon
  }
}